<template>
	<div class="class">
		<teacherNav :current="current" @info-event="myInfoEvent" @public-event="publicEvent"></teacherNav>
		<div class="class_cont bg_blue">
			<div class="class_div radius8 bs bg_white">
				<div class="class_title flex">
					<p class="f30px cl_dark">我的组卷</p>
					<router-link to="/task_topic" class="organize_set cl_white tc">创建组卷</router-link>
				</div>
				<div class="task_paper_screen mat30">
					<div class="test_screen cl_gray">
						<div class="test_screen_l f16px"><span class="inline">学科</span><i class="inline">：</i></div>
						<div class="test_screen_r tc">
							<span class="test_screen_list bg_gray" v-for="(item,index) in subject" :key="index" :class="{'on':item.subjectId==subject_cur}"
							 @click="subjectCheck(item.subjectId)">{{item.subjectName}}</span>
						</div>
					</div>
					<div class="test_screen cl_gray">
						<div class="test_screen_l f16px"><span class="inline">年级</span><i class="inline">：</i></div>
						<div class="test_screen_r tc">
							<span class="test_screen_list bg_gray" v-for="(item,index) in grade" :key="index" :class="{'on':item.gradeId==grade_cur}"
							 @click="gradeCheck(item.gradeId)">{{item.gradeName}}</span>
						</div>
					</div>
					<!-- <div class="test_screen cl_gray">
						<div class="test_screen_l f16px"><span class="inline">章节</span><i class="inline">：</i></div>
						<div class="test_screen_r tc">
							<span class="test_screen_list bg_gray" v-for="(item,index) in grade" :key="index" :class="{'on':item.gradeId==grade_cur}"
							 @click="chapterCheck(item.gradeId)">{{item.gradeName}}</span>
						</div>
					</div>
						<div class="test_screen cl_gray">
						<div class="test_screen_l f16px"><span class="inline">知识点</span><i class="inline">：</i></div>
						<div class="test_screen_r tc">
							<span class="test_screen_list bg_gray" v-for="(item,index) in grade" :key="index" :class="{'on':item.gradeId==grade_cur}"
							 @click="knowledgeCheck(item.gradeId)">{{item.gradeName}}</span>
						</div>
					</div> -->
				</div>
				<div class="f18px cl_gray mat30">共 <span class="cl_yel">{{total}}</span> 套试卷</div>
				<div class="task_paper_cont mat20">
					<div class="task_paper_list flex radius8 bs mab30" v-for="(item,index) in list" :key="index">
						<div class="task_paper_list_l">
							<p class="f20px cl_dark inline clip">{{item.name}}</p>
							<p class="cl_gray mat10">题目数量：{{item.question_num}}</p>
						</div>
						<div class="org_paper_list_r flex tc">
							<router-link :to="{ path: '/organize_details', query: { paper_id: item.id }}" class="cl_violet org_paper_list_edit mar10">编辑</router-link>
							<div class="cl_red org_paper_list_delete cur mar10" @click="deletes(item.id)"><img src="../../../static/delete_red.png" class="mar5" /><span>删除</span></div>
							<div class="task_video_list_item_btn cur tc cl_white on" v-if="item.is_join == 1" @click="remove(index)">-移出作业篮</div>
							<div class="task_video_list_item_btn cur tc cl_white" v-else @click="join(index)">+加入作业篮</div>
						</div>
					</div>
				</div>
				<div class="famous_page flex" v-if="list.length > 0">
					<div class="famous_page_l f16px cl_gray"> </div>
					<div class="famous_page_r cl_dark">
						<el-pagination background layout="prev, pager, next, jumper"
						@current-change="handleCurrentChange" :page-size="pageSize" :current-page="currentPage" :total="total"></el-pagination>
					</div>
				</div>
				<div class="choice_empty tc f18px cl_gray" v-if="list.length == 0">
					<p>暂时还没有组卷</p>
				</div>
			</div>
		</div>
		<!-- 作业篮 -->
		<router-link to="/basket" class="basket">
			<el-popover placement="bottom-start" trigger="hover">
				<div class="basket_hide" v-if="basket.subject_data.length > 0">
					<table class="basket_hide_cont f16px">
						<tr class="basket_hide_item cl_dark">
							<td align="center">学科</td>
							<td align="center">视频</td>
							<td align="center">试卷</td>
						</tr>
						<tr class="basket_hide_item cl_gray" v-for="(item,index) in basket.subject_data" :key="index">
							<td align="center">{{item.subjectName}}</td>
							<td align="center">{{item.video_num == null || item.video_num == "" || item.video_num == 0 ? "-" : item.video_num}}</td>
							<td align="center">{{item.shijuan_num == null || item.shijuan_num == "" || item.shijuan_num == 0 ? "-" : item.shijuan_num}}</td>
						</tr>
					</table>
					<div class="tc mat10">
						<router-link to="/basket" class="cl_blue">预览预选作业 ></router-link>
					</div>
				</div>
				<el-button slot="reference" class="basket_link">
					<img src="../../../static/basket_icon.png" />
					<div class="basket_link_text cl_white">
						<p class="f20px">作业篮</p>
						<p class="f16px mat5"><span class="cl_yel">{{basket.count}}</span>项内容</p>
					</div>
				</el-button>
			</el-popover>
		</router-link>
	</div>
</template>

<script>
	import teacherNav from '../../components/teacher_nav.vue'
	
	export default {
		name: 'organize',
		components: {
			teacherNav,
		},
		props: {
			
		},
		data () {
			return {
				myInfo: {},
				public: {},
				current: {
					navCur: 5,
					listCur: 0,
					open: 0,
				},
				subject: [], //学科
				subject_cur: "",
				grade: [], //年级
				grade_cur: "",
				type: [], //类型
				type_cur: "",
				list: [],
				currentPage: 1, //当前页数
				pageSize: 20, //每页数量
				total: 0, //总页数
				basket: {
					count: 0,
					subject_data: [],
				}, //作业篮
			}
		},
		created() {
			
		},
		mounted() {
			this.getSubject();
			this.getBasket();
		},
		methods: {
			myInfoEvent (data) {
				this.myInfo = data;
			},
			publicEvent (data) {
				this.public = data;
			},
			//作业篮
			getBasket () {
				this.$get("/api/teacher/get_basket_statistics_message",{
					token: localStorage.getItem("token"),
				})
				.then(res => {
					this.basket = res.data;
				});
			},
			//学科
			getSubject () {
				this.$get("/api/material/get_subject_data",{})
				.then(res => {
					this.subject = res.data;
					this.subject_cur = this.subject[0].subjectId;
					this.getGrade();
				});
			},
			//年级
			getGrade () {
				this.$get("/api/teacher/get_school_grade_data",{
					token: localStorage.getItem("token"),
				})
				.then(res => {
					this.grade = res.data;
					this.grade_cur = this.grade[0].gradeId;
					this.getList();
				});
			},
			//试卷
			getList () {
				this.$get("/api/teacher/get_my_test_data",{
					token: localStorage.getItem("token"),
					subject_id: this.subject_cur,
					grade_id: this.grade_cur,
					province_id: "",
					chapter_id: "",
					page: this.currentPage,
					limit: this.pageSize,
				})
				.then(res => {
					this.list = res.data.data;
					this.total = res.data.total;
				});
			},
			subjectCheck (e) {
				this.subject_cur = e;
				this.currentPage = 1;
				this.getList();
			},
			gradeCheck (e) {
				this.grade_cur = e;
				this.currentPage = 1;
				this.getList();
			},
			//删除
			deletes (e) {
				this.$messageBox.confirm('确定删除吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					this.$get("/api/teacher/post_test_del",{
						token: localStorage.getItem("token"),
						id: e,
					})
					.then(res => {
						this.$message({
							type: 'success',
							message: res.msg,
							duration: 1500,
						});
						this.getList();
					});
				}).catch(() => {
					
				});
			},
			//加入
			join (e) {
				var item_ids = this.list[e].id;
				this.$get("/api/teacher/post_join_basket",{
					token: localStorage.getItem("token"),
					item_type: "test", //video视频,test组卷,papers试卷,exam校本试卷
					item_ids: item_ids,
					pack_id: "",
				})
				.then(res => {
					this.list[e].is_join = 1;
					this.$message({
						type: 'success',
						message: res.msg,
						duration: 1500,
					});
					this.getBasket();
				});
			},
			//移除
			remove (e) {
				var item_ids = this.list[e].id;
				this.$get("/api/teacher/post_remove_basket",{
					token: localStorage.getItem("token"),
					item_type: "test", //video视频,test组卷,papers试卷,exam校本试卷
					item_ids: item_ids,
					pack_id: "",
				})
				.then(res => {
					this.list[e].is_join = 0;
					this.$message({
						type: 'success',
						message: res.msg,
						duration: 1500,
					});
					this.getBasket();
				});
			},
			handleCurrentChange: function(currentPage){
				this.currentPage = currentPage;
				this.getList();
			},
		},
	}
</script>

<style>
</style>
